import { KeyIndicatorColor } from "react-migration/lib/map/useKeyIndicatorTags";
import { Belts } from "./types";

const defaultGreyBeltIndicator = {
  tag: `Not in grey belt`,
  color: KeyIndicatorColor.LIGHT_GRAY,
};

export function getGreenBeltIndicator(belt: Belts | null) {
  if (!belt) {
    return [defaultGreyBeltIndicator];
  }

  const { greyBeltPercentage, designation } = belt;
  const overallFavourability =
    designation?.designation_attributes.find((item) => item.key === "overall_favourability")?.value ?? "Unknown";

  if (greyBeltPercentage > 0) {
    const greyBeltCoverageIndicator = {
      tag: `${greyBeltPercentage}% ${overallFavourability}`,
      color: KeyIndicatorColor.DEFAULT,
    };

    return [greyBeltCoverageIndicator];
  }

  return [defaultGreyBeltIndicator];
}
